import { useState, useEffect } from 'react';
import { supabase } from './lib/supabase';
import Auth from './pages/Auth';
import Journal from './pages/Journal';

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const isRecovery = window.location.hash.includes('type=recovery');
  const [needsPasswordReset, setNeedsPasswordReset] = useState(isRecovery);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === 'PASSWORD_RECOVERY') {
          setSession(session);
          setNeedsPasswordReset(true);
        } else {
          setSession(session);
          if (event !== 'INITIAL_SESSION') setNeedsPasswordReset(false);
        }
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  if (loading) return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', fontFamily: 'Poppins, sans-serif',
      fontSize: 13, color: '#8A8070', background: '#FFFEFC'
    }}>
      loading…
    </div>
  );

  if (needsPasswordReset) return <Auth initialView="reset" onResetDone={() => setNeedsPasswordReset(false)} />;
  return session ? <Journal session={session} /> : <Auth />;
}
